import { render, staticRenderFns } from "./CancelamentoDiarioCadastro.vue?vue&type=template&id=732cf97b&"
import script from "./CancelamentoDiarioCadastro.vue?vue&type=script&lang=js&"
export * from "./CancelamentoDiarioCadastro.vue?vue&type=script&lang=js&"
import style0 from "./CancelamentoDiarioCadastro.vue?vue&type=style&index=0&id=732cf97b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports